import { userRolesLoaded } from '../actions';
import { fetchAuthorizedJsonSaga, JsonApiResponse, UserClientConfig } from './fetch-json-saga';

/**
 * Fetches the roles for the authenticated user from /api/user/v1/roles.
 *
 * Roles drive UI feature visibility (e.g. showing inactive product versions to
 * verifiers). Dispatches USER_ROLES_LOADED so the userRoles reducer stores them
 * and selectIsVerifier can derive the flag without touching the JWT.
 */
export function* fetchRolesSaga(config: UserClientConfig): Generator<unknown, void, unknown> {
  yield* fetchAuthorizedJsonSaga(config, '/roles', (parsed: JsonApiResponse) =>
    userRolesLoaded((parsed?.result?.roles as string[]) ?? []),
  );
}
